<template>
  <span>
    <slot v-bind="{ exportxlsx }">
      <v-btn @click="exportxlsx" color="grey" outline>
        <em class="fas fa-file-export" />
        &nbsp;
        {{ $t('export') }}&nbsp;
      </v-btn>
    </slot>
  </span>
</template>

<script>
import * as XLSX from 'xlsx'
export default {
  props: {
    filename: {
      type: String,
      default: 'exportedfile'
    }
  },
  methods: {
    async exportxlsx() {
      let vm = this
      this.$emit('onExport', {
        submitData: function (json) {
          const dataWS = XLSX.utils.json_to_sheet(json)
          const wb = XLSX.utils.book_new()
          XLSX.utils.book_append_sheet(wb, dataWS)
          XLSX.writeFile(wb, vm.filename + '.xlsx')

          return true
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/elements/Exportxlsx2.vue